import React, { useState, useEffect } from 'react'
import moment from 'moment'
import API from '../../../../../services/API'
import AnDatePicker from '../../../../../components/DateTime/DatePicker'
import { DetailRow } from '../../../../../components/Cards/DetailsBox'
import PDFViewer from '../../../../../components/Modals/PDFViewer'
// MUI Imports
import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '30rem',
  maxWidth: '100vw',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  borderColor: 'none',
  maxHeight: 500,
  overflow: 'auto',
  padding: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
}

const AddQualification = ({
  employee,
  setQualList,
  selectedQualification,
  setSelectedQualification,
  getQualifications,
}) => {
  const [openAddNew, setOpenAddNew] = useState(false)
  const [courseDate, setCourseDate] = useState(null)
  const [courseName, setCourseName] = useState('')
  const [expiryDate, setExpiryDate] = useState(null)

  const [certificate, setCertificate] = useState()
  const [uploading, setUploading] = useState(false)
  let s3url
  let s3key

  const [viewPDF, setViewPDF] = useState(false)

  const handleDelete = () => {
    API.delete(
      '/employees/deleteQualification/' + selectedQualification._id
    ).then((res) => {
      if (res.status === 200) {
        getQualifications()
        setSelectedQualification(null)
      }
    })
  }

  useEffect(() => {
    setCourseDate(null)
    setCourseName('')
    setExpiryDate(null)
  }, [openAddNew])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setUploading(true)
    const syncToDb = () => {
      API.post('/employees/addQualification', {
        employee: employee._id,
        courseDate,
        courseName,
        expiryDate,
        certificate: s3key,
      })
        .then((res) => {
          if (res.status === 200) {
            setQualList((prev) => [
              ...prev,
              {
                qualificationDate: courseDate,
                qualificationName: courseName,
                qualificationExpiryDate: expiryDate,
                certificate: s3key,
                _id: res.data._id,
              },
            ])
            setOpenAddNew(false)
          }
        })
        .catch((e) => console.error(e))
        .finally(() => setUploading(false))
    }
    if (certificate) {
      // TODO: Should this be done on the backend instead of sharing URL to frontend?
      await API.post('gets3uploadurl', {
        folder: 'employees/qualifications',
        extension: certificate[0].type.split('/')[1],
      })
        .then((res) => {
          s3url = res.data.url
          s3key = res.data.key
          API.put(s3url, certificate[0], {
            headers: {
              'Content-Type': 'application/pdf',
            },
          })
          syncToDb()
        })
        .catch((e) => console.error(e))
    } else {
      syncToDb()
    }
  }

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      <Button
        onClick={() => setOpenAddNew(true)}
        variant="contained"
        startIcon={<AddIcon />}
        size="small"
        sx={{ mb: 1 }}
      >
        Add Qualification
      </Button>
      <Modal
        open={!!selectedQualification}
        onClose={() => setSelectedQualification(null)}
      >
        <Box sx={modalStyle}>
          <Typography variant="title3" textAlign="center">
            {selectedQualification?.qualificationName}
          </Typography>
          <DetailRow
            label="Date"
            value={
              selectedQualification?.qualificationDate
                ? moment(selectedQualification?.qualificationDate).format(
                    'Do MMM YYYY'
                  )
                : 'No Date'
            }
          />
          <DetailRow
            label="Expiry"
            value={
              selectedQualification?.qualificationExpiryDate
                ? moment(selectedQualification?.qualificationExpiryDate).format(
                    'Do MMM YYYY'
                  )
                : 'No Expiry'
            }
          />

          {selectedQualification?.certificate ? (
            <Button onClick={() => setViewPDF(true)}>View Certificate</Button>
          ) : (
            <DetailRow label="Certificate" value="None" />
          )}
          <PDFViewer
            open={viewPDF}
            onClose={() => setViewPDF(false)}
            s3key={selectedQualification?.certificate}
          />
          <Button color="error" onClick={handleDelete}>
            Delete Qualification
          </Button>
        </Box>
      </Modal>
      <Modal open={openAddNew} onClose={() => setOpenAddNew(false)}>
        <Box sx={modalStyle} component="form" onSubmit={handleSubmit}>
          <Typography variant="title2" textAlign="center">
            Add a Qualification
          </Typography>
          <AnDatePicker
            disableFuture
            label="Date of Qualification"
            value={courseDate}
            required
            onChange={(newDate) => setCourseDate(newDate)}
          />
          <TextField
            label="Course Name"
            required
            value={courseName}
            fullWidth
            autoComplete="off"
            onChange={(e) => setCourseName(e.target.value)}
          />
          <TextField
            type="file"
            inputProps={{ accept: ['application/pdf'] }}
            onChange={(e) => setCertificate(e.target.files)}
          />
          <AnDatePicker
            label="Expiry Date"
            value={expiryDate}
            onChange={(newDate) => setExpiryDate(newDate)}
          />
          <Button
            type="button"
            color="error"
            onClick={() => setOpenAddNew(false)}
          >
            Close
          </Button>
          <Button type="submit" color="success" disabled={uploading}>
            Submit
          </Button>
        </Box>
      </Modal>
    </Box>
  )
}

export default AddQualification
